// Import dependencies
import * as turf from '@turf/turf';
import { get_lands_full_list } from '../map/Map_helpers.js';
import { searchDataGetByInseeCode } from '../../../actions/capa';


var lands_full_list = null;
var search_data = null;

// INITIALIZE SEARCH
export const search_initiate = async (setSearchParameters, dispatch, lands_full_list_source, capacity) => {
    // Set local lands full list
    lands_full_list = lands_full_list_source;
    console.log("INITIATE SEARCH", lands_full_list);
    // Set states
    if (lands_full_list) {
        setSearchParameters({
            map_update: null,
            nb_land: lands_full_list.length,
            filters_available: {},
            filters: {},
            result_list: {
                update_trigger: null,
                list: []
            },
            search_data_state: "fetching",
        })
        // Get search_data
        console.log("-FETCHING SEARCH DATA- : Loading...");
        // dispatch(searchDataGetByInseeCode(capacity?.city?.inseecode, handleSearchDataGetSuccess, handleSearchDataGetFail));
        dispatch(searchDataGetByInseeCode(capacity?.city?.inseecode,
            function (data) {
                console.log("-FETCHING SEARCH DATA- : Success", data);
                search_data = data;
                var search_data_state = "none";
                if (data?.parcelles) { search_data_state = "done" }
                // Add data to lands
                // var nb_items_data = 0;
                // lands_full_list.forEach(land => {
                //     try {
                //         var arrond = land.id.substring(5, 8);
                //         var section = land.id.substring(8, 10);
                //         var land_data_list = data.parcelles[arrond][section];
                //         for (var i = 0; i < land_data_list.length; i++) {
                //             if (land.id === land_data_list[i].id) {
                //                 land.properties.data = land_data_list[i];
                //                 nb_items_data++;
                //                 break;
                //             }
                //         }
                //     } catch (error) {
                //         // console.log("ERROR enriching land", land?.id, error);
                //     }
                // })
                // console.log("TOTAL ENRICHED LANDS ", nb_items_data, " OVER ", lands_full_list.length);
                // Update hook
                setSearchParameters({
                    map_update: null,
                    nb_land: lands_full_list.length,
                    filters_available: data?.filtres || {},
                    filters: {},
                    result_list: {
                        update_trigger: null,
                        list: []
                    },
                    search_data_state: search_data_state,
                })
            },
            function (error) {
                console.log("-FETCHING SEARCH DATA- : Error", error.response.data);
                search_data = null;
                setSearchParameters({
                    map_update: null,
                    nb_land: lands_full_list.length,
                    filters_available: {},
                    filters: {},
                    result_list: {
                        update_trigger: null,
                        list: []
                    },
                    search_data_state: "none",
                })
            }));
    }
    else {
        setSearchParameters(null);
        search_data = null;
    }
}


// APPLY ALL FILTERS
export const search_apply_filters = (searchParameters, setSearchParameters) => {
    console.log("APPLY SEARCH", searchParameters);
    var filters = searchParameters?.filters ? JSON.parse(JSON.stringify(searchParameters.filters)) : {};
    var result_list = {
        update_trigger: Date.now().toString(),
        list: []
    }
    // OPERATE CHECK OF EACH LAND and UPDATE lands_full_list
    // Loop th lands full list
    lands_full_list.forEach((land, land_index) => {
        if (land?.id) {
            var search_match = '+';
            var land_model = {
                id: land.id,
                bbox: land.properties?.bbox || null,
                // com: turf.getCoord(turf.centroid(land)),
            };
            // FILTERS
            var filters_keys = Object.keys(filters);
            if (filters_keys.length > 0) {
                // search_match = '0';
                filters_keys.forEach(filter_name => {
                    if (filters[filter_name]?.values_current) {
                        // Reset nb result of the filter
                        if (land_index === 0) { filters[filter_name].result.nb_land = 0 }
                        // Check if land is matching filters criteria
                        var land_match_res = false;
                        var land_match_val = null;
                        if (land?.properties && Object.keys(land.properties).includes(filters[filter_name].format.key) && land.properties[filters[filter_name].format.key] !== null) {
                            land_match_val = land.properties[filters[filter_name].format.key];
                            // Check min and max values
                            if (filters[filter_name]?.values_current && Object.keys(filters[filter_name].values_current).includes("min") && Object.keys(filters[filter_name].values_current).includes("max")) {
                                if (land_match_val >= filters[filter_name].values_current.min && land_match_val <= filters[filter_name].values_current.max) {
                                    land_match_res = true;
                                    filters[filter_name].result.nb_land++;
                                    land_model[filters[filter_name].format.key] = land.properties[filters[filter_name].format.key];
                                }
                                else { land_match_res = false }
                            }
                            // Add other filters types here
                        }
                        // Set search match value
                        if (land_match_res === false) {
                            // search_match = '0';
                        }
                        // else { search_match = '100' }
                        else { search_match = search_match + "+" }
                    }
                })
            }
            // Update result list
            // if (search_match !== '0') {
            if (search_match.length === filters_keys.length + 1) {
                land_model.search_match = search_match;
                result_list.list.push(land_model);
                search_match = '100';
            }
            else {
                search_match = '0';
            }
            // Update full list for map show
            land.properties.search_match = search_match;
        }
    });

    // Sort if needed

    // Update searchParameters to get resuts for each filters
    // setSearchParameters({ ...searchParameters, map_update: ("+" + (Date.now()).toString()) });
    setSearchParameters({ ...searchParameters, filters: filters, result_list: result_list, map_update: null });

    // Update capacity ??? to keep trace of search params

    return lands_full_list;
}

// FILTERS
export const search_create_filter = (filter_id, searchParameters, setSearchParameters) => {
    var format = {};
    if (filter_id === "land_area") {
        format = {
            label: "Superficie",
            name: "land_area",
            key: "s",
            pre: "",
            post: " m²",
            prettynum: 0,
            increment: 10,
        };
        // search_create_filter_land_area(searchParameters, setSearchParameters);
    }
    else if (filter_id === "land_compacity") {
        format = {
            label: "Compacité",
            name: "land_compacity",
            key: "Im",
            pre: "",
            post: "",
            prettynum: 2,
            increment: 0.01,
        };
        // search_create_filter_land_area(searchParameters, setSearchParameters);
    }
    else if (filter_id === "built_ground_area") {
        format = {
            label: "Emprise bâtie",
            name: "built_ground_area",
            key: "sb",
            pre: "",
            post: " m²",
            prettynum: 0,
            increment: 10,
        };
        // search_create_filter_built_ground_area(searchParameters, setSearchParameters);
    }
    search_create_filter_num(searchParameters, setSearchParameters, format);
}

// FILTER : LAND_AREA
export const search_create_filter_num = (searchParameters, setSearchParameters, format) => {
    console.log("CREATE FILTER NUM", lands_full_list, searchParameters);
    // Create filter
    // var format = {
    //     label: "Superficie",
    //     name: "land_area",
    //     key: "s",
    //     pre: "",
    //     post: " m²",
    //     prettynum: 0,
    // };
    var stats = {
        all: {
            min: null,
            max: null,
            mean: null,
            sum: 0,
            nb: 0,
            chart_data: [],
        }
    }
    var chart_data_obj = {};
    // Loop th lands full list
    var is_already_imported = false;
    var nb_items_data = 0;
    lands_full_list.forEach((land, index) => {
        if (land?.id) {
            // Add data to land
            try {
                // Search if data already imported
                if (index === 0 && Object.keys(land.properties).includes(format.key)) {
                    is_already_imported = true;
                }
                // If data not already imported => get it from search_data
                if (!is_already_imported) {
                    land.properties[format.key] = null;
                    if (search_data?.parcelles) {
                        var arrond = land.id.substring(5, 8);
                        var section = land.id.substring(8, 10);
                        for (var i = 0; i < search_data.parcelles[arrond][section].length; i++) {
                            if (search_data.parcelles[arrond][section][i].id === land.id) {
                                land.properties[format.key] = null;
                                if (Object.keys(search_data.parcelles[arrond][section][i]).includes(format.key)) {
                                    land.properties[format.key] = search_data.parcelles[arrond][section][i][format.key];
                                }
                                // Add bbox to perform fly to land
                                if (!Object.keys(land.properties).includes("bbox") && Object.keys(search_data.parcelles[arrond][section][i]).includes("bb")) {
                                    land.properties.bbox = search_data.parcelles[arrond][section][i].bb;
                                }
                                // Stop for loop
                                break;
                            }
                        }
                    }
                }
                // Set chart data
                if (Object.keys(land.properties).includes(format.key) && land.properties[format.key] > 0) {
                    nb_items_data++;
                    var multiplier = format.prettynum > 0 ? Math.pow(10, format.prettynum) : 1;
                    var value_rounded = Math.floor(land.properties[format.key] * multiplier) / multiplier;
                    var value_modulated = value_rounded % format.increment;
                    var value_incremented = value_rounded;
                    if (value_modulated > 0) { value_incremented = value_rounded - value_modulated }
                    // var value_key = value_incremented.toString();
                    var value_key = value_incremented.toFixed(format.prettynum);
                    if (!Object.keys(chart_data_obj).includes(value_key)) { chart_data_obj[value_key] = 0 }
                    chart_data_obj[value_key]++;
                    // Calculate stats i
                    stats.all.nb++;
                    stats.all.sum += land.properties[format.key];
                    if (stats.all.min === null || stats.all.min > land.properties[format.key]) { stats.all.min = land.properties[format.key] }
                    if (stats.all.max === null || stats.all.max < land.properties[format.key]) { stats.all.max = land.properties[format.key] }
                }
            } catch (error) {
                land.properties[format.key] = null;
            }
        }
    });
    // Calculate stats global
    stats.all.mean = Math.round(stats.all.sum / stats.all.nb);
    // Calculate range limits
    var multiplier = format.prettynum > 0 ? Math.pow(10, format.prettynum) : 1;
    var min_rounded = Math.floor(stats.all.min * multiplier) / multiplier;
    var min_modulated = min_rounded % format.increment;
    var min_incremented = min_rounded;
    if (min_modulated > 0) { min_incremented = min_rounded - min_modulated }
    if (format.prettynum > 0) { min_incremented = parseFloat(min_incremented.toFixed(format.prettynum)) } else { min_incremented = parseInt(min_incremented.toFixed(0)) }
    var max_rounded = Math.ceil(stats.all.max * multiplier) / multiplier;
    var max_modulated = max_rounded % format.increment;
    var max_incremented = max_rounded;
    if (max_modulated > 0) { max_incremented = max_rounded + (format.increment - max_modulated) }
    if (format.prettynum > 0) { max_incremented = parseFloat(max_incremented.toFixed(format.prettynum)) } else { max_incremented = parseInt(max_incremented.toFixed(0)) }

    // Update Search Parameters
    var result_list = searchParameters?.result_list ? JSON.parse(JSON.stringify(searchParameters.result_list)) : { update_trigger: null, list: [] };
    var filters = searchParameters?.filters ? JSON.parse(JSON.stringify(searchParameters.filters)) : {};
    filters[format.name] = {
        stats: stats,
        values_default: {
            min: min_incremented,
            max: max_incremented,
        },
        values_current: {
            min: min_incremented,
            max: max_incremented,
        },
        isIgnored: false,
        result: {
            nb_land: lands_full_list.length,
            nb_land_data: nb_items_data,
        },
        chart: {
            data: chart_data_obj,
        },
        format: format
    }
    console.log("TOTAL CALCULATED ", nb_items_data, " OVER ", lands_full_list.length);
    setTimeout(() => {
        console.log("timed");
        if (result_list?.list && result_list.list.length > 0) {
            console.log("RE-APPLY FILTERS");
            search_apply_filters({ ...searchParameters, filters: filters, result_list: result_list, map_update: null }, setSearchParameters);
        }
        else {
            setSearchParameters({ ...searchParameters, filters: filters, result_list: result_list, map_update: null });
        }
    }, 2000)
}

// FILTER : BUILT_GROUND_AREA
export const search_create_filter_built_ground_area = (searchParameters, setSearchParameters) => {
    console.log("CREATE FILTER BUILT GROUND AREA", lands_full_list, searchParameters);
    // Create filter
    var format = {
        label: "Emprise bâtie",
        key: "bga",
        pre: "",
        post: " m²",
        prettynum: 0,
    };
    var stats = {
        all: {
            min: null,
            max: null,
            mean: null,
            sum: 0,
            nb: 0,
            chart_data: [],
        }
    }
    var chart_data_obj = {};
    // Loop th lands full list
    var is_already_imported = false;
    var nb_items_data = 0;
    lands_full_list.forEach((land, index) => {
        if (land?.id) {
            // Add data to land
            try {
                // Search if data already imported
                if (index === 0 && Object.keys(land.properties).includes(format.key)) {
                    is_already_imported = true;
                }
                // If data not already imported => get it from search_data
                if (!is_already_imported) {
                    land.properties.area = null;
                    if (search_data?.parcelles) {
                        var arrond = land.id.substring(5, 8);
                        var section = land.id.substring(8, 10);
                        for (var i = 0; i < search_data.parcelles[arrond][section].length; i++) {
                            if (search_data.parcelles[arrond][section][i].id === land.id) {
                                land.properties.area = search_data.parcelles[arrond][section][i]?.s || null;
                                land.properties.bbox = search_data.parcelles[arrond][section][i]?.bb || null;
                                break;
                            }
                        }
                    }
                }
                // Calculate area
                // land.properties.area = turf.area(land);
                // Set chart data
                if (land?.properties?.area && land.properties.area > 0) {
                    nb_items_data++;
                    var area_rounded = Math.floor(land.properties.area);
                    var area_modulated = area_rounded % 10;
                    var area_incremented = area_rounded;
                    if (area_modulated > 0) { area_incremented = area_rounded - area_modulated }
                    var area_key = area_incremented.toString();
                    if (!Object.keys(chart_data_obj).includes(area_key)) { chart_data_obj[area_key] = 0 }
                    chart_data_obj[area_key]++;
                    // Calculate stats i
                    stats.all.nb++;
                    stats.all.sum += land.properties.area;
                    if (stats.all.min === null || stats.all.min > land.properties.area) { stats.all.min = land.properties.area }
                    if (stats.all.max === null || stats.all.max < land.properties.area) { stats.all.max = land.properties.area }
                }
            } catch (error) {
                land.properties.area = null;
            }
        }
    });
    // Calculate stats global
    stats.all.mean = Math.round(stats.all.sum / stats.all.nb);
    // Calculate range limits
    var min_rounded = Math.floor(stats.all.min);
    var min_modulated = min_rounded % 10;
    var min_incremented = min_rounded;
    if (min_modulated > 0) { min_incremented = min_rounded - min_modulated }
    var max_rounded = Math.ceil(stats.all.max);
    var max_modulated = max_rounded % 10;
    var max_incremented = max_rounded;
    if (max_modulated > 0) { max_incremented = max_rounded + (10 - max_modulated) }

    // Update Search Parameters
    var filters = searchParameters?.filters ? JSON.parse(JSON.stringify(searchParameters.filters)) : {};
    filters.built_ground_area = {
        stats: stats,
        values_default: {
            min: min_incremented,
            max: max_incremented,
        },
        values_current: {
            min: min_incremented,
            max: max_incremented,
        },
        isIgnored: false,
        result: {
            nb_land: lands_full_list.length,
        },
        chart: {
            data: chart_data_obj,
        },
        format: format
    }
    console.log("TOTAL CALCULATED ", nb_items_data, " OVER ", lands_full_list.length);
    setTimeout(() => {
        console.log("timed");
        setSearchParameters({ ...searchParameters, filters: filters, result_list: { update_trigger: null, list: [] }, map_update: null });
    }, 2000)
}